import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/index.vue";
import Win3 from "../views/win3EBC.vue";

Vue.use(VueRouter);
// routes 国内站路由
// routes2 大赛独立站路由
// import {routes,routes2} from "./routes"
export const routes = [
  {
    path: "/",
    name: "Home",
    component: Win3,
  },
  {
    path: "/cn",
    name: "Home-cn",
    component: Win3,
  },
  {
    path: "/en",
    name: "Home-en",
    component: Win3,
  },
  {
    path: "/ko",
    name: "Home-ko",
    component: Win3,
  },
  {
    path: "/ja",
    name: "Home-ja",
    component: Win3,
  },
  {
    path: "/ug",
    name: "Home-ug",
    component: Win3,
  },
  {
    path: "/tw",
    name: "Home-tw",
    component: Win3,
  },
  {
    path: "/th",
    name: "Home-th",
    component: Win3,
  },
  {
    path: "/vn",
    name: "Home-vn",
    component: Win3,
  },
];


const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});
// win3单独路由


export default router;
